import { addHours, endOfMonth, formatISO, parseISO, startOfMonth } from 'date-fns';
import { API } from 'src/api';

export const getGoogleEvents = async (date: Date) => {
  const startDate = formatISO(startOfMonth(date));
  const endDate = formatISO(endOfMonth(date));
  const data = await API.get(`/dashboard/tasks-by-date?limit=5&start=${startDate}&end=${endDate}`);
  const googleEvents: any[] = [];

  if (data && data.data.data?.length) {
    data.data?.data
      ?.filter((item) => item.type === 'google')
      .map((item) => {
        const taskData: any = {
          id: item._id,
          title: item.name,
          resource: {
            itemId: item._id,
            boardId: item?.board?._id,
            type: 'google',
            googleCalendarId: item?.calendarId,
            googleEventId: item?.eventId,
            calendarEmail: item?.email,
          },
          borderColor: item.backgroundColor || '#254DDA',
        };

        if (item.start_date) {
          taskData.start = parseISO(item.start_date);
        }
        if (item.end_date) {
          taskData.end = parseISO(item.end_date);
        } else {
          taskData.end = addHours(parseISO(item.start_date), 2);
        }
        googleEvents.push(taskData);
      });
  }
  return googleEvents;
};
